import React from "react";
import { Helmet } from 'react-helmet-async';
import '../../../assets/styles/Frontend.css'
import heroImg from "../../../assets/images/frontend.jpeg";
import techImg from "../../../assets/images/ecommercedevelopment.jpg";

const FrontendDevelopment = () => {
  return (
    <>
      <Helmet>
        {/* <!-- Primary Meta Tags for SEO --> */}
        <title> Frontend Development – BuddyTech Solutions </title>
        <meta name="description" content="Reactive and responsive frontend development with React, Angular, Vue, optimized for performance and design." />
        <meta name="keywords" content="frontend development, React, Vue, Angular" />

        {/* <!-- Open Graph / Facebook Meta Tags --> */}
        <meta property="og:title" content="Frontend Development – BuddyTech Solutions" />
        <meta property="og:description" content="Reactive and responsive frontend development with React, Angular, Vue, optimized for performance and design." />
        <meta property="og:keywords" content="frontend development, React, Vue, Angular" />
        <meta property="og:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
        <meta property="og:url" content="https://buddytechsolutions.in/services/development/frontend" />
        <meta property="og:type" content="website" />

        {/* <!-- Optional: Facebook App ID --> */}
        {/* <!-- <meta property="fb:app_id" content="your_facebook_app_id" /> --> */}

        {/* <!-- Twitter Meta Tags --> */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Frontend Development – BuddyTech Solutions" />
        <meta name="twitter:description" content="Reactive and responsive frontend development with React, Angular, Vue, optimized for performance and design." />
        <meta name="twitter:keywords" content="frontend development, React, Vue, Angular" />
        <meta name="twitter:image" content="https://buddytechsolutions.in/assets/images/thumbnailimages.jpg" />
      </Helmet>
      <div className="frontend-container">
        <header className="frontend-hero">
          <div className="frontend-hero-content">
            <h1>Front-End Development</h1>
            <p>
              We craft pixel-perfect, high-performance user interfaces that provide seamless and responsive user experiences across all devices.
            </p>
          </div>
          <img src={heroImg} alt="Frontend Development" className="frontend-hero-img" />
        </header>

        <section className="frontend-section">
          <div className="frontend-text">
            <h2>What We Do</h2>
            <p>
              Our front-end developers specialize in building fast, accessible, and beautiful web interfaces using modern frameworks and tools like React, Vue, Angular, and TypeScript. We prioritize responsive layouts, accessibility, and design accuracy.
            </p>
            <ul>
              <li>Responsive & Mobile-first Design</li>
              <li>Component-based Development</li>
              <li>Cross-Browser Compatibility</li>
              <li>Performance Optimization</li>
              <li>Pixel-perfect Implementation</li>
            </ul>
          </div>
          <img src={techImg} alt="Frontend Technologies" className="frontend-img" />
        </section>

        <section className="frontend-tools">
          <h2>Technologies We Use</h2>
          <div className="tools-grid">
            <span>HTML5</span>
            <span>CSS3</span>
            <span>JavaScript</span>
            <span>TypeScript</span>
            <span>React</span>
            {/* <span>Vue</span> */}
            <span>Angular</span>
            <span>Tailwind CSS</span>
            <span>SASS</span>
            <span>Next.js</span>
          </div>
        </section>

        <section className="contact-options">
          <div className="contact-card email">
            <h2>📧 Email</h2>
            <p>Send us an email for inquiries, support or collaboration opportunities.</p>
            <a href="mailto:developerjayaprakash91@gmail.com" target="_blank" rel="noopener noreferrer">
              Send Email
            </a>
          </div>

          <div className="contact-card whatsapp">
            <h2>💬 WhatsApp</h2>
            <p>Start a chat with us on WhatsApp for quick responses and updates.</p>
            <a href="https://wa.me/919842084312" target="_blank" rel="noopener noreferrer">
              Chat on WhatsApp
            </a>
          </div>

          <div className="contact-card phone">
            <h2>📞 Call Us</h2>
            <p>Prefer to talk directly? Give us a call anytime during business hours.</p>
            <a href="tel:+919842084312">Call Us</a>
          </div>
        </section>
      </div>
    </>
  );
};

export default FrontendDevelopment;